import React from 'react'
import { Divider } from 'antd'
import UserPreferenceChangeLanguage from './UserPreferenceChangeLanguage/UserPreferenceChangeLanguage'
import UserPreferenceChangeCurrency from './UserPreferenceChangeCurrency/UserPreferenceChangeCurrency'
import UserPreferenceChangeConsent from './UserPreferenceChangeConsent/UserPreferenceChangeConsent'

const UserPreferenceForm: React.FC = () => {

  return <>
    {/* Language */}
    <UserPreferenceChangeLanguage />
    {/* Currency */}
    <UserPreferenceChangeCurrency />
    <Divider />
    {/* Commercial Communications Consent */}
    <UserPreferenceChangeConsent consentType='COMMERCIAL' />
    <Divider />
    {/* Allow Susbrice on Sales */}
    <UserPreferenceChangeConsent consentType='SUSCRIBE_SALES' />
  </>
}

export default UserPreferenceForm
